"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRANDS_LABELS = void 0;
const ru_json_1 = __importDefault(require("./ru.json"));
const en_json_1 = __importDefault(require("./en.json"));
const cn_json_1 = __importDefault(require("./cn.json"));
const es_json_1 = __importDefault(require("./es.json"));
const de_json_1 = __importDefault(require("./de.json"));
const fr_json_1 = __importDefault(require("./fr.json"));
const it_json_1 = __importDefault(require("./it.json"));
const ja_json_1 = __importDefault(require("./ja.json"));
const pt_json_1 = __importDefault(require("./pt.json"));
const tr_json_1 = __importDefault(require("./tr.json"));
const pl_json_1 = __importDefault(require("./pl.json"));
const ro_json_1 = __importDefault(require("./ro.json"));
const sk_json_1 = __importDefault(require("./sk.json"));
const ua_json_1 = __importDefault(require("./ua.json"));
exports.BRANDS_LABELS = {
    RU: ru_json_1.default,
    EN: en_json_1.default,
    CN: cn_json_1.default,
    ES: es_json_1.default,
    DE: de_json_1.default,
    FR: fr_json_1.default,
    IT: it_json_1.default,
    JA: ja_json_1.default,
    PT: pt_json_1.default,
    TR: tr_json_1.default,
    PL: pl_json_1.default,
    RO: ro_json_1.default,
    SK: sk_json_1.default,
    UA: ua_json_1.default,
};
